export const ADD_USER = "ADD_USER";
export const ADD_TOKEN = "ADD_TOKEN";
export const ADD_GRADES = "ADD_GRADES";
export const ADD_ASSIGNED_SCRIPTS = "ADD_ASSIGNED_SCRIPTS";
export const ADD_MARKED_SCRIPTS = "ADD_MARKED_SCRIPTS";
export const ADD_SELECTED_SUBJECT = "ADD_SELECTED_SUBJECT";
export const ADD_AVAILABLE_SCRIPTS = "ADD_AVAILABLE_SCRIPTS";
export const ADD_USERS = "ADD_USERS";